import React from 'react';

// Theme
import { ConfigProvider, message, ThemeConfig } from 'antd';
import { PRIMARY_COLOR } from './constants/colors';

// Components
import RootComponent from './RootComponent';

// Redux
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';

// Locale
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import es from 'antd/locale/es_ES';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import AddCompanyModal from './components/modals/addCompanyModal';
import { DEBUG_ENV_LABEL, DEBUG_HOST_LABEL, DEBUG_MODE } from './config';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/Argentina/Buenos_Aires');

dayjs.locale('es');

const borderRadius = 15 as const;
const inputBorderRadius = 12 as const;

message.config({
  duration: 5
});

const theme: ThemeConfig = {
  components: {
    Input: {
      borderRadius: inputBorderRadius
    },
    InputNumber: {
      borderRadius: inputBorderRadius
    },
    Select: {
      borderRadius: inputBorderRadius
    },
    DatePicker: {
      borderRadius: inputBorderRadius
    },
    Button: {
      borderRadius
    }
  },
  token: {
    fontFamily: 'Encode Sans',
    colorPrimary: PRIMARY_COLOR
  }
} as const;

const App: React.FC = () => {
  return (
    <ConfigProvider locale={es} theme={theme}>
      {DEBUG_MODE && (
        <div style={{height: '20px', background: '#e74c3c', color: '#fff', padding: '5px', textAlign: 'center', fontSize: '10px', position: 'sticky', top: 0, zIndex: 9999 }}>
          <strong>Entorno:</strong> {DEBUG_ENV_LABEL} | <strong>Host:</strong> {DEBUG_HOST_LABEL}
        </div>
      )}
      <div style={DEBUG_MODE ? {height: '20px'} : {}}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AddCompanyModal
                title="Gracias por registrarte"
                subtitle="Antes de continuar, es necesario que registres la información de tu empresa."
              />

              <RootComponent />
            </PersistGate>
          </Provider>
      </div>
    </ConfigProvider>
  );
};

export default App;
